package er.prateek.crossly.firebase

/** Wraps Firebase Analytics so game/progression code never depends on GitLive types directly. */
interface AnalyticsLogger {
    fun logEvent(name: String, params: Map<String, Any> = emptyMap())
    fun setAnalyticsEnabled(enabled: Boolean)
}

object NoOpAnalyticsLogger : AnalyticsLogger {
    override fun logEvent(name: String, params: Map<String, Any>) = Unit
    override fun setAnalyticsEnabled(enabled: Boolean) = Unit
}
